module.exports = __webpack_public_path__ + "03_very_short_black.836b0b8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/03_very_short_black.png
// module id = jAyZ
// module chunks = 0